import { Injectable } from "@angular/core";
import { Document } from "../models/document.model";
import { GraphQLService } from "./graphql.service";
import { HttpClient } from "@angular/common/http";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable()
export class DocumentService extends GraphQLService<Document> {

  constructor(
    http: HttpClient,
    snackBar: MatSnackBar
  ) {
    super(http, snackBar)
  }

  documents(iso: string, unames: string[]) {
    return this.findAll(`{ documents(iso: "${ iso }", unames: "${ unames.join(',') }") { id slug uname name } }`)
  }

  document(id: number, iso: string) {
    return this.find(`{ document(id: ${ id }, iso: "${ iso }") { id slug uname name content } }`)
  }

}
